/*V2*/
/** @jsx jsx */
import * as React from "react";
import * as _ from "lodash";
import { IMedicinePrescription } from "@curefit/ehr-common";
import { IAdditionalInstruction, IMedicineFrequency, IDosage } from "@curefit/care-common";
import { DosageSlots } from "../../../utils/AppConstants";
import { MedicineInstructionCodes } from "../../../models/Consultation";
import IMedicineType from "../../../models/staticData/IMedicineType";
import AppUtils from "../../../utils/AppUtils";
import { css, jsx } from "@emotion/core";
import { patientConsSummary } from "../../../styles/patient/patientConsSummary";

/**
 * Created by deepak on 06/12/17.
 */


export interface MedicinePrescriptionViewProps {
    staticMedicineTypes: IMedicineType[];
    medicinePrescriptionList: IMedicinePrescription[];
    additionalInstructions?: IAdditionalInstruction[];
}

export const getFormattedDosage = (dosageList: IDosage[]): string => {
    let dosageStr = "";
    if (!_.isEmpty(dosageList) && dosageList.length > 0) {
        let breakfastDosage = dosageList.filter(dosage => dosage.slot === DosageSlots.BREAKFAST);
        let lunchDosage = dosageList.filter(dosage => dosage.slot === DosageSlots.LUNCH);
        let dinnerDosage = dosageList.filter(dosage => dosage.slot === DosageSlots.DINNER);
        dosageStr = dosageStr + (breakfastDosage.length > 0 ? breakfastDosage[0].quantity : 0);
        dosageStr = dosageStr + " - " + (lunchDosage.length > 0 ? lunchDosage[0].quantity : 0);
        dosageStr = dosageStr + " - " + (dinnerDosage.length > 0 ? dinnerDosage[0].quantity : 0);
    }
    return dosageStr;
}

export const getFormattedIntakeConditions = (conditionsList: string[]) => {
    let conditions: any = [];
    conditionsList && conditionsList.forEach(function (ele) {
        conditions.push(ele.displayValue);
    });
    return conditions.join(", ");
}

export const getFormattedFrequencyString = (medicineFrequency: IMedicineFrequency) => {
    let frequencyString = "";
    if (!_.isEmpty(medicineFrequency)) {
        let frequencyCount = medicineFrequency.count;
        if (!_.isNull(frequencyCount)) frequencyString = frequencyString.concat(frequencyCount.toString());
        let frequencyUnit = medicineFrequency.unit;
        if (!_.isNull(frequencyUnit)) frequencyString = frequencyString.concat(`/${frequencyUnit.toString().toLowerCase()}`);
    }
    return frequencyString;
}

export const getFormattedDurationString = (medicineDuration: IMedicineFrequency) => {
    let frequencyString = "";
    if (!_.isEmpty(medicineDuration)) {
        let frequencyCount = medicineDuration.count;
        if (!_.isNull(frequencyCount)) frequencyString = frequencyString.concat(frequencyCount.toString());
        let frequencyUnit = medicineDuration.unit;
        if (!_.isNull(frequencyUnit)) frequencyString = frequencyString.concat(` ${frequencyUnit.toString().toLowerCase()}`);
    }
    return frequencyString;
}

export const getMedicineTypeTextFromValue = (medicineType: string, staticMedicineTypes: IMedicineType[]) => {
    let index = _.values(staticMedicineTypes).map(item => item.medicineType).indexOf(medicineType);
    if (index !== -1) return _.values(staticMedicineTypes).filter(item => item.medicineType === medicineType)[0].displayText;
    else return medicineType;
}

const MedicinePrescriptionView: React.StatelessComponent<MedicinePrescriptionViewProps> = (props: MedicinePrescriptionViewProps) => {
    let showAdditionalInst = props.additionalInstructions && props.additionalInstructions.length > 0;
    const isMobile: boolean = AppUtils.getIsMobile();
    return (
        <div>
            {isMobile && props.medicinePrescriptionList && props.medicinePrescriptionList.length > 0 &&
                <div>
                    {_.map(props.medicinePrescriptionList, (medicinePrescription: IMedicinePrescription, num: number) => {
                        let intakeConditions = !_.isEmpty(medicinePrescription.medicineInstructions) ? getFormattedIntakeConditions(medicinePrescription.medicineInstructions) : "";
                        let medicineType = !_.isEmpty(medicinePrescription.medicineType) ? medicinePrescription.medicineType : "";
                        let medicineName = !_.isEmpty(medicinePrescription.genericName) ? medicinePrescription.genericName.displayValue : "";
                        let medicineBrandName = !_.isEmpty(medicinePrescription.brand) ? medicinePrescription.brand.displayValue : "";
                        let medicineDosage = !_.isEmpty(medicinePrescription.dosage) ? medicinePrescription.dosage : "";
                        let frequencyString = this.getFormattedFrequencyString(medicinePrescription.medicineFrequency);
                        let durationString = this.getFormattedDurationString(medicinePrescription.medicineDuration);
                        let formattedDosage = !_.isEmpty(medicinePrescription.slotList) ?
                            getFormattedDosage(medicinePrescription.slotList) : "";
                        console.log(medicinePrescription);
                        return (
                            <div key={num} css={patientConsSummary.medicineCard}>
                                <div css={patientConsSummary.medicineName}>{medicineBrandName}</div>
                                <div css={patientConsSummary.description}>
                                    {medicineType &&
                                        <span>{medicineType} | </span>
                                    }
                                    {medicineDosage &&
                                        <span>{medicineDosage} | </span>
                                    }
                                    {frequencyString &&
                                        <span>{frequencyString} | </span>
                                    }
                                    {intakeConditions &&
                                        <span>{intakeConditions} | </span>
                                    }
                                    {formattedDosage &&
                                        <span>{formattedDosage} | </span>
                                    }
                                    {durationString &&
                                        <span>{durationString} </span>
                                    }
                                </div>
                            </div>
                        )
                    })}
                </div>
            }
            {
                !isMobile && props.medicinePrescriptionList && props.medicinePrescriptionList.length > 0 &&
                <div className="medicine-prescription-view-container">
                    <table style={{ tableLayout: "auto", width: "100%" }}>
                        <thead>
                            <tr>
                                <th className={"brandon-bold"}>TYPE</th>
                                <th className={"brandon-bold"}>MEDICINE</th>
                                <th className={"brandon-bold"}>DOSAGE</th>
                                <th className={"brandon-bold"}>FREQUENCY</th>
                                <th className={"brandon-bold"}>CONDITION</th>
                            </tr>
                        </thead>
                        <tbody>
                            {_.map(props.medicinePrescriptionList, (medicinePrescription: IMedicinePrescription, num: number) => {
                                let intakeConditions = !_.isEmpty(medicinePrescription.medicineInstructions) ? getFormattedIntakeConditions(medicinePrescription.medicineInstructions) : "";
                                let medicineType = !_.isEmpty(medicinePrescription.medicineType) ? medicinePrescription.medicineType : "";
                                let medicineName = !_.isEmpty(medicinePrescription.genericName) ? medicinePrescription.genericName.displayValue : "";
                                let medicineBrandName = !_.isEmpty(medicinePrescription.brand) ? medicinePrescription.brand.displayValue : "";
                                let medicineDosage = !_.isEmpty(medicinePrescription.dosage) ? medicinePrescription.dosage : "";
                                let frequencyString = this.getFormattedFrequencyString(medicinePrescription.medicineFrequency);
                                let durationString = this.getFormattedDurationString(medicinePrescription.medicineDuration);
                                let formattedDosage = !_.isEmpty(medicinePrescription.slotList) ?
                                    getFormattedDosage(medicinePrescription.slotList) : "";
                                return (
                                    <tr key={num}>
                                        <td>{getMedicineTypeTextFromValue(medicineType, props.staticMedicineTypes)}</td>
                                        <td className="medicine-name-container highlighted-text">
                                            <div>{medicineBrandName}</div>
                                            <div className={"medicine-brand"}>{medicineName}</div>
                                        </td>
                                        <td>{medicineDosage}</td>
                                        <td>
                                            <div className="freq-row">
                                                <div className="in-blk med-type">{frequencyString}</div>
                                                {
                                                    !_.isEmpty(durationString) &&
                                                    <div className="in-blk med-frq">
                                                        <div className="in-blk placeholder-text placeholder-text-container">for</div> {durationString}
                                                    </div>
                                                }
                                                {
                                                    !_.isEmpty(formattedDosage) &&
                                                    <div className="in-blk">
                                                        <div className="in-blk placeholder-text placeholder-text-container">at</div> {formattedDosage}
                                                    </div>
                                                }

                                            </div>
                                        </td>
                                        <td>{intakeConditions}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                    {showAdditionalInst && <div>
                        <div>ADDITIONAL INSTRUCTIONS</div>
                        <div>{props.medicinePrescriptionList.map((instruction, index) => {
                            return <div>{instruction.comment}</div>
                        })}</div>
                    </div>}
                </div>

            }
            {props.medicinePrescriptionList && props.medicinePrescriptionList.length <= 0 &&
                <div className={"no-record-found-label"}>No Current Medications found</div>
            }
        </div>
    )
}

export default MedicinePrescriptionView;